import { useState, useEffect } from 'react';

const useScrollHeight = (offset: number = 330): number => {
  const [scrollHeight, setScrollHeight] = useState(window.innerHeight - offset);

  useEffect(() => {
    const handleResize = () => {
      setScrollHeight(window.innerHeight - offset);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [offset]);

  return scrollHeight;
};

export default useScrollHeight;
